import { createFileRoute } from "@tanstack/react-router";
import { AdminCategoriesPage } from "../components/shop/admin-categories-page.tsx";

export const Route = createFileRoute("/produkter/kategorier")({ component: AdminCategoriesPage });
